jQuery('document').ready(function(){



    if ( jQuery( "#search-filter-form-583 .sf-item-0" ).length ) {

        if ( jQuery( "#search-filter-form-583 .sf-item-0" ).hasClass("sf-option-active") ) {
            jQuery( "#search-filter-form-583 .sf-item-0" ).removeClass("sf-option-active");
        }
        var attr = jQuery("#search-filter-form-583 .sf-item-0 input").attr("checked");
        if (typeof attr !== typeof undefined && attr !== false) {
            jQuery("#search-filter-form-583 .sf-item-0 input").removeAttr("checked");
        }
    }


    if ( jQuery( "#search-filter-results-583 .cateringmenu-results" ).length ) {
        if (! jQuery( "#search-filter-results-583 .cateringmenu-results" ).is(':empty')){
            jQuery( "#search-filter-results-583 .cateringmenu-results" ).empty();
        }
    }


    //englanti
    if ( jQuery( "#search-filter-form-4093 .sf-item-0" ).length ) {

        if ( jQuery( "#search-filter-form-4093 .sf-item-0" ).hasClass("sf-option-active") ) {
            jQuery( "#search-filter-form-4093 .sf-item-0" ).removeClass("sf-option-active");
        }
        var attr = jQuery("#search-filter-form-4093 .sf-item-0 input").attr("checked");
        if (typeof attr !== typeof undefined && attr !== false) {
            jQuery("#search-filter-form-4093 .sf-item-0 input").removeAttr("checked");
        }
    }


    if ( jQuery( "#search-filter-results-4093 .cateringmenu-results" ).length ) {
        if (! jQuery( "#search-filter-results-4093 .cateringmenu-results" ).is(':empty')){
            jQuery( "#search-filter-results-4093 .cateringmenu-results" ).empty();
        }
    }



});
